import React, { useState } from "react";
import cx from "classnames";
import { uniqueId } from "lodash";

import styles from "./InputRadioSpecial.module.scss";

const InputRadioGroupSpecial = ({ title, subtitle, className, children }) => (
  <fieldset className={cx(styles.group, className)}>
    <legend className={styles.legend}>
      <span className="gkit-p-15 gkit-bold">{title}</span>
      {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
    </legend>
    <div className={styles.options}>{children}</div>
  </fieldset>
);

const InputRadioSpecial = ({
  image,
  children,
  className,
  onClick,
  checked,
  id,
  ...props
}) => {
  const [referenceId] = useState(() => uniqueId("radio-special-"));
  return (
    <div className={cx(styles.specialRadio, className)}>
      <input
        type="radio"
        className={styles.input}
        {...props}
        value={id}
        id={referenceId}
        checked={checked}
        onChange={onClick}
      />
      <label className={styles.card} htmlFor={referenceId}>
        <span className={styles.imageContainer}>
          {image && <img src={image} alt="" className={styles.image} />}
        </span>
        <span className={styles.title}>{children}</span>
      </label>
    </div>
  );
};

export { InputRadioGroupSpecial, InputRadioSpecial };
